// ─── ANNOUNCEMENT — Modal "Cosa c'è di nuovo" post-login ────────────────────
//
// `ANNOUNCEMENT_VERSION` viene bumped manualmente a ogni nuovo annuncio
// (vedi docs/superpowers/specs/2026-05-12-announcement-modal-design.md §8).
// Policy bump (memory `feedback_announcement_version_bump_policy`): SOLO
// minor/major release (1.13.0, 2.0.0). NON per patch (1.12.1, 1.12.2).
//
// `ANNOUNCEMENT_BODY_MD` è il contenuto markdown leggero parsato a runtime
// da `window.parseLightMarkdown` (src/core.js).
//
// Entrambe esposte su `window` (vedi main.js bridge) perché lette dai moduli
// ESM (ui-onboarding.js `shouldShowAnnouncement`).
//
// HOTFIX 2026-05-12: `ANNOUNCEMENT_VERSION=''` disattiva il modal a runtime
// (`shouldShowAnnouncement` ritorna false se !v). Il contenuto placeholder
// di test era visibile a TUTTI gli utenti dopo deploy v1.7.0 — rimosso
// d'urgenza. Per riattivare con un annuncio reale: bump `ANNOUNCEMENT_VERSION`
// + sostituisci body.
//
// v1.12.0 (2026-05-19): popup release announcement — mirror email content.
// Source-of-truth contenuto: `docs/release/v1.12.0/02-popup.md`.
//
// Estratto da `index.html` <script> inline in PR refactor/bkl016-pr1
// (2026-05-21, parte completamento ADR-0005 split).

export const ANNOUNCEMENT_VERSION = '1.12.0';

export const ANNOUNCEMENT_BODY_MD = `Grazie a tutti voi che avete dato dei feedback. 🙏

La nuova versione di Coach AI è ora online, e se è cresciuta così in fretta è grazie al vostro supporto.

**Coach AI ha un look più pulito e leggibile**, soprattutto da mobile. Niente di stravolto, solo più ordine dove serviva.

Oltre al restyling completo, ci sono tre cose nuove che puoi provare subito:

- 📊 **Widget "Oggi"** in home — il tuo trend a colpo d'occhio
- 🔄 **Rigenera un singolo piano** dalla Scheda Rapida, senza dover rifare tutto da capo
- 📅 **Imposta i tuoi giorni di allenamento** dal profilo, e il piano si adatta

Le migliorie non finiscono qui: 🥗 **è arrivato il campo allergeni** (separato dalle intolleranze, per le situazioni più delicate), 🌍 **più cucine selezionabili** (italiana, mediterranea, esotica e altre), il **profilo è più ricco e personalizzabile**, e il **grafico del peso compare in home appena hai due misurazioni**.

E due tocchi pratici: puoi ✅ **spuntare i pasti completati** con macro residue in tempo reale, e **cambiare una singola ricetta** del piano se non ti convince — senza rifare tutto.

Insomma, tante novità non solo stilistiche! ✨`;
